import styled, { css } from 'styled-components'

export const ContainerQuestionMarkWithBorder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ModalContentText = styled.p`
  ${({ marginBottom }) => css`
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 163.42%;
    text-align: center;
    color: #858585;
    margin-bottom: ${marginBottom || '0'};
    white-space: pre-line;
  `}
`

export const TitleModal = styled.h1`
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 700 !important;
  font-size: 24px !important;
  line-height: 30px;
  text-align: center;
  color: #000 !important;
`

export const ModalBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`
